document.addEventListener('DOMContentLoaded', () => {

    const filterBar = document.querySelector('.js-filter-bar')

    if (filterBar !== null) {

        const searchBar = document.querySelector('.js-search-bar')
        searchBar.addEventListener('click', function() {
            const searchForm = document.querySelector('form.js-search-form')

            searchForm.submit()
        })

        const filterButtons = document.querySelectorAll('.js-filter-button')

        filterButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const filter = btn.getAttribute('data-filter')
                const hiddenInput = document.querySelector('.js-hidden-filter')
                hiddenInput.value = filter

                const filterForm = document.querySelector('.js-filters-form')
                filterForm.submit();
            })
        })
    }
})